module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-237.857d00c.woff2";